<template>
    <div class="modal fade" id="modal-playAudio" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content filter-content">
                <div class="modal-header">
                    <h4>ID {{ sac.id }}</h4>
                    <button type="button" class="close" @click="close">&times;</button>
                </div>
                <div class="modal-body">
                    <div>
                        <Loading v-if="loading_audio" />
                        <player ref="wavesurfer" :class="(!audio.hash) ? 'hidden' : ''" :audio_hash="audio.hash" />
                        <br>
                        <Loading v-if="loading_transcript" />
                        <div style="text-align: right;">
                            <font-awesome-icon icon="sync" class="info pointer" @click="refresh_transcript(sac.id)"/>
                        </div>
                        <textarea class="form-control form-control-sm" name="transcricao" id="transcricao" cols="30" rows="6"  v-model="sac.transcricao"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/mixins/api.js"
import replace from "@/mixins/replace.js"
import player from "@/components/Tools/Player"

export default {
    name: 'modal-playAudio',
    props: ['sac'],
    mixins: [api, replace],
    components: { player },

    data: () => {
        return {

            loading_audio: false,
            loading_transcript: false,
            audio: { hash: null, path: null, transcricao: null },

        }
    },

    watch: {
        sac() {

            this.load_data()
        }
    },


    methods: {
        async load_data() {
            this.audio.hash = null;
            this.load_audio();
        },

        async load_audio() {
            this.audio.path = this.sac.path;
            this.carrega_audio(this.audio.path);
        },

        async carrega_audio(caminho) {

            if (!caminho) {
                this.audio.hash = null;
                this.loading_audio = false;
            } else {
                this.loading_audio = true;
                const response = await this.POST("SAC/pegaAudio", { path: caminho});
                if (this.loading_audio) {
                    this.audio.hash = response;
                }
                this.loading_audio = false;
            }
        },

        async refresh_transcript(id) {
            this.loading_transcript = true;
            const response = await this.POST(`SAC/Transcript/${id}`);
            const sac = await this.GET(`SAC/${id}`);
            this.loading_transcript = false;
            this.sac.transcricao = sac.result['transcricao'];
        },

        close() {
            this.$emit('close');
            $("#modal-playAudio").modal('hide');
        }
    }
}
</script>

<style scoped>
.modal-content {
    width: 125%;
    background: snow;
}

.modal-header {
    border-bottom: 1px solid #147F75;
}
</style>